"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbUSDAuthenticator = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "MbUSDAuthenticator", { enumerable: true, get: function () { return features_1.MbUSDAuthenticator; } });
//# sourceMappingURL=index.js.map